import mutations from "./mutations";
import actions from './actions';
import getters from './getters';

export default{
    namespaced: true,
    state(){
        return {
            vouchers: [],
            promos: [],
            pages: 0
        }
    },
    mutations,
    actions,
    getters
}